import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rounded',
})
export class RoundedPipe implements PipeTransform {
  isImperial =
    localStorage.getItem('imperial') &&
    localStorage.getItem('imperial') === 'true';

  transform(value: number, args: string): string {
    const limit = !this.isImperial ? 1000 : 1000 * 0.62137;
    const marker = !this.isImperial ? 'KM' : 'M';
    if (args === 'Swim') {
      return this.roundToTwo(value) + '<br>m';
    } else {
      if (value > 1000) {
        return this.roundToTwo(value / limit) + '<br>' + marker;
      }
      return value + '\nm';
    }
  }

  roundToTwo(num) {
    return +Math.round((num + Number.EPSILON) * 100) / 100;
  }
}
